import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  DeliveryState,
  IDelivery,
  IDeliveryFlowItem,
  IDeliveryMode,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class Delivery
  extends BaseModel<Delivery, 'Delivery'>
  implements IDelivery
{
  static override readonly modelName: AbilitySubjectType = 'Delivery';

  @Type(() => Date)
  date?: Date;
  @Type(() => Date)
  deletedAt?: Date | null;
  deliveryModeId!: string;
  extId?: string | undefined;
  label?: string | undefined;
  flows?: IDeliveryFlowItem[];
  deliveryMode?: IDeliveryMode;
  state!: DeliveryState;
}
